import { defineStore } from 'pinia'

interface State {
  accounting_lock_date: string,
  vat_percentage: number,
}

export const useAppStore = defineStore('App', {
  state: (): State => ({
    vat_percentage: 0,
    accounting_lock_date: '',
  }),
  actions: {
    setVatPercentage (vatPercentage: number) {
      this.vat_percentage = vatPercentage
    },
    setLockDate (lockDate: string) {
      this.accounting_lock_date = lockDate
    },
  },
})
